module.exports = function init_wpdt() {

  // wait for wpdt to initialize
  setTimeout(function() {

    // target any table within the #order-hx-table-container element
    const table_selector = '#order-hx-table-container table';
    const table_element = document.querySelector(table_selector);
    
    if (!table_element) {
      return;
    }
    
    const table_id = table_element.id;
    
    if (table_id && typeof wpDataTables[table_id] !== 'undefined') {
      
      // add callback for when the table is drawn (initial draw & filtering)
      wpDataTables[table_id].addOnDrawCallback(function() {
        process_all_rows(table_id);
      });
      
      // initial styling
      process_all_rows(table_id);
    } 
  }, 1000);

  function process_all_rows(table_id) {

    const timestamp_column_index = 0; // index of the timestamp column
    
    // get table API
    const table_api = wpDataTables[table_id].api();
    
    // first, reset all rows to default state
    // this gets ALL rows, not just filtered ones
    const all_nodes = table_api.rows().nodes();
    for (let i = 0; i < all_nodes.length; i++) {
      const row = all_nodes[i];
      row.classList.remove('submission-row-even', 'submission-row-odd', 'submission-first-row', 'submission-child-row');
      
      const first_cell = row.querySelector('td:first-child');
      if (first_cell) {
        first_cell.classList.remove('submission-hidden-cell');
      }
    }
    
    // now process only visible/filtered rows
    const visible_rows = table_api.rows({order: 'current', search: 'applied'}).data();
    const visible_nodes = table_api.rows({order: 'current', search: 'applied'}).nodes();
    
    // group rows by timestamp
    const timestamp_groups = {};
    for (let i = 0; i < visible_rows.length; i++) {
      const timestamp = visible_rows[i][timestamp_column_index];
      if (!timestamp_groups[timestamp]) {
        timestamp_groups[timestamp] = [];
      }
      timestamp_groups[timestamp].push(i);
    }
    
    // apply styling to each group
    let group_count = 0;
    for (const timestamp in timestamp_groups) {
      group_count++;
      const row_indices = timestamp_groups[timestamp];
      const row_class = group_count % 2 === 0 ? 'submission-row-even' : 'submission-row-odd';
      
      for (let i = 0; i < row_indices.length; i++) {
        const row_index = row_indices[i];
        const row = visible_nodes[row_index];
        
        // apply row color class
        row.classList.add(row_class);
        
        if (i === 0) {
          // first row in timestamp group
          row.classList.add('submission-first-row');
        } else {
          // child rows in timestamp group
          row.classList.add('submission-child-row');
          
          // hide timestamp in child rows
          const first_cell = row.querySelector('td:first-child');
          if (first_cell) {
            first_cell.classList.add('submission-hidden-cell');
          }
        }
      }
    }
  }
};